<template>
  <div class="d-flex flex-column align-center justify-center">
    <v-img
      :src="content.url_thumbnail"
      :style="content.dsc_midia_tipo === 'backstage-video' ? 'border-radius: var(--sc-radius-xl);' : ''"
    />
    <span class="mt-2 ml-1 align-self-start"> {{ this.label }}</span>
  </div>
</template>

<script>
export default {
  props: {
    content: Object,
  },
  data() {
    return {
      label: null,
    };
  },
  created() {
    this.label =
      this.content.dsc_descricao_conteudo && this.content.dsc_direitos_conteudo
        ? `${this.content.dsc_descricao_conteudo} — ${this.content.dsc_direitos_conteudo}`
        : this.content.dsc_descricao_conteudo && !this.content.dsc_direitos_conteudo
        ? `${this.content.dsc_descricao_conteudo}`
        : !this.content.dsc_descricao_conteudo && this.content.dsc_direitos_conteudo
        ? `${this.content.dsc_direitos_conteudo}`
        : "";
  },
};
</script>

<style lang="scss" scoped>
div {
  width: 100%;
}
.v-image {
  width: 100%;
  height: auto;
}
span {
  color: #333333;
  display: block;
  font-weight: 400;
  font-size: 0.8rem;
}

/* The mobile styles are now the default, so the specific media query for it is no longer needed. */

@media (min-width: 768px) {
  div {
    width: 90%;
  }
}

// @media (min-width: 1024px) {
//   .v-image {
//     min-height: 360px !important;
//     max-height: 640px !important;
//   }
// }
</style>
